import {
  isGroupConversation,
  isP2pConversation,
  isThreadConversation,
  isVoiceConversation,
} from '../shared/utils';
import { ChatHeaderGroup } from './ChatHeaderGroup';
import { ChatHeaderP2P } from './ChatHeaderP2P';
import { ChatHeaderVoice } from './ChatHeaderVoice';
import { ThreadHeader } from './ThreadHeader';
import { ChatHeaderProps } from './types';

export const ChatHeader = ({ conversation, onClose }: ChatHeaderProps) => {
  if (isP2pConversation(conversation))
    return <ChatHeaderP2P conversation={conversation} onClose={onClose} />;

  if (isVoiceConversation(conversation))
    return <ChatHeaderVoice conversation={conversation} />;

  if (isThreadConversation(conversation))
    return <ThreadHeader conversation={conversation} />;

  if (isGroupConversation(conversation))
    return <ChatHeaderGroup conversation={conversation} onClose={onClose} />;

  return null;
};
